import { uuid } from '../../../CodesThatsGottaGoSomewhereElse';
import { StoreState } from '../../../concepts/revive/Store';
import { CoolWriteStore } from '../../packages/voting/VotingViewState';
import { Meeting } from './Meeting';
import { Phase } from './Phase';

const phaseSetupModelTemplate = {
    name: '',
    time: 0,
    timeUsed: null,
    tools: {} as Record<string, boolean>,
    active: false,
    incognito: false,
    concealment: false,
};

export class SetupPhaseModel extends CoolWriteStore(phaseSetupModelTemplate) {
    public key = uuid();

    public static create(n: number = 1) {
        const psm = new SetupPhaseModel();
        psm.update({ name: `Activity #${n}`, tools: {}, });
        return psm;
    }

    public static createWith(state: Partial<StoreState<SetupPhaseModel>>) {
        const psm = new SetupPhaseModel();
        psm.update(state);
        return psm;
    }

    public static createFromExisting(meeting: Meeting, phase: Phase, isNew?: boolean) {
        const activePhase = meeting?.children?.[meeting.activePhase]?.as(Phase) ?? null;
        const model = SetupPhaseModel.createWith({
            name: isNew ? `Activity #${meeting.children.length}` : phase.name,
            time: isNew ? 0 : phase.time / 60 / 1000,
            timeUsed: !isNew && phase === activePhase ? (activePhase.time - meeting.getTimeReadingMs()) / 60 / 1000 : null,
            tools: Object.fromEntries(phase.tools.map(x => [x, true])),
            active: phase === activePhase,
            incognito: phase.incognito,
            concealment: phase.concealment,
        });
        if (!isNew) {
            model.key = phase.key;
        }
        return model;
    }
}
